module.exports = "<sq-home-screen class=\"flexFill\"></sq-home-screen>\n";